import config from "config";

import BuildingSceneLayer from "@arcgis/core/layers/BuildingSceneLayer";
import SceneLayer from "@arcgis/core/layers/SceneLayer";
import IntegratedMeshLayer from "@arcgis/core/layers/IntegratedMeshLayer";
import PointCloudLayer from "@arcgis/core/layers/PointCloudLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import VoxelLayer from "@arcgis/core/layers/VoxelLayer";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import ElevationLayer from "@arcgis/core/layers/ElevationLayer";

import Collection from "@arcgis/core/core/Collection";
import VoxelVolumeStyle from "@arcgis/core/layers/voxel/VoxelVolumeStyle";

import geometryTools from "./geometryTools";
import BookmarkUtils from "utils/BookmarkUtils";

const LAYER_TYPE_CLASS = {
  scene: SceneLayer,
  bim: BuildingSceneLayer,
  "integ-mesh": IntegratedMeshLayer,
  "point-cloud": PointCloudLayer,
  feature: FeatureLayer,
  voxel: VoxelLayer,
};
export default class LayerToggleUtil {
  static toggle3DLayer(
    category,
    indexOrLayerObj,
    forceEnable,
    mapView,
    isSecondMap = false,
    forceVisible = false
  ) {
    console.debug("Calling the utility function - toggle3DLayer");
    let layerList = config[`mapList${isSecondMap ? "2" : ""}`];
    var item3DObj = null;
    if (typeof indexOrLayerObj === "number")
      item3DObj = layerList.layer3D[category][indexOrLayerObj];
    else item3DObj = indexOrLayerObj;

    let tagIndices = item3DObj.tags.filter((c) => c.indexOf(":") > -1);

    let categoryGrpLyr = mapView.map.allLayers.find(
      (i) => i.title === category && i.type === "group"
    );

    if (!categoryGrpLyr) {
      var layer3DGroup = mapView.map.layers.find(
        (i) => i.title === "3D Layers"
      );
      categoryGrpLyr = new geometryTools.GroupLayer({ title: category });
      layer3DGroup.add(categoryGrpLyr);
    }

    if (
      typeof forceEnable != "undefined" &&
      item3DObj?.enabled == forceEnable
    ) {
      if (item3DObj.layer) item3DObj.layer.visible = forceVisible;
      return;
    }

    item3DObj.enabled =
      typeof forceEnable != "undefined" ? forceEnable : !item3DObj.enabled;
    if (item3DObj.enabled) {
      var parameter = null;
      if ("url" in item3DObj)
        parameter = {
          title: item3DObj.title,
          url: item3DObj.url,
          visible: forceVisible,
        };
      else
        parameter = {
          portalItem: { id: item3DObj.id },
          visible: forceVisible,
        };
      if ("title" in item3DObj) {
        parameter = {
          ...parameter,
          title: item3DObj.title,
        };
      }
      if ("layerId" in item3DObj) {
        parameter = {
          ...parameter,
          layerId: item3DObj.layerId,
        };
      }
      if ("type" in item3DObj && item3DObj.type === "voxel") {
        var volStyles = new Collection();
        volStyles.add(
          new VoxelVolumeStyle({
            verticalExaggeration: 1,
          })
        );
        parameter = {
          ...parameter,
          volumeStyles: volStyles,
          spatialReference: new SpatialReference({
            wkid: 102140,
            latestWkid: 2326,
          }),
        };
      }

      parameter.outFields = "*";

      parameter.popupEnabled = item3DObj.type === "bim";

      item3DObj.layer = new LAYER_TYPE_CLASS[item3DObj.type](parameter);
      // let tagIndices = Object.keys(subLvDetail);
      if (!tagIndices.length) categoryGrpLyr.add(item3DObj.layer);
      else {
        tagIndices.sort();
        let allGrpLayers = LayerToggleUtil.findLast3DGroupNode(
          tagIndices,
          categoryGrpLyr
        );
        allGrpLayers.pop().add(item3DObj.layer);
      }
      if ("terrain" in item3DObj)
        LayerToggleUtil.toggleTerrain(mapView, item3DObj.terrain, true);
    } else {
      if (item3DObj.layer) item3DObj.layer.destroy();
      mapView.map.remove(item3DObj.layer);
      item3DObj.layer = null;
      let allGrpLayers = LayerToggleUtil.findLast3DGroupNode(
        tagIndices,
        categoryGrpLyr
      );
      allGrpLayers.reverse();
      allGrpLayers.push(categoryGrpLyr);
      allGrpLayers.forEach((i) => {
        if (i.layers.length === 0) {
          i.parent.remove(i);
          i.destroy();
        }
      });
      if ("terrain" in item3DObj)
        LayerToggleUtil.toggleTerrain(mapView, item3DObj.terrain, false);
    }
    console.debug(item3DObj, layerList.layer3D);
  }
  static toggleTerrain(mapView, terrainInfo, value) {
    if (value) {
      let terrainLayer = new ElevationLayer({
        portalItem: { id: terrainInfo.id },
        title: terrainInfo.metaData.originSlopeNos,
      });
      mapView.map.ground.layers.add(terrainLayer);
      terrainInfo.layer = terrainLayer;
    } else {
      mapView.map.ground.layers.remove(terrainInfo.layer);
    }
  }
  static findLast3DGroupNode(tags, categoryGrpLyr) {
    let lastNode = categoryGrpLyr;
    let nodes = tags.map((i) => {
      i = i.substr(i.indexOf(":") + 1);
      let thisNode = lastNode.layers.find((lyr) => lyr.title === i);
      if (!thisNode) {
        thisNode = new geometryTools.GroupLayer({ title: i });
        lastNode.add(thisNode);
      }
      lastNode = thisNode;
      return thisNode;
    });
    console.debug(nodes);
    return nodes;
  }
  static toggle3DLayerByTag(
    category,
    tag,
    forceEnable,
    mapView,
    isSecondMap = false,
    forceVisible = false
  ) {
    let layerList = config[`mapList${isSecondMap ? "2" : ""}`];
    layerList.layer3D[category].forEach((i) => {
      if (i.tags.some((i) => i == tag)) {
        console.debug(i);
        LayerToggleUtil.toggle3DLayer(
          category,
          i,
          forceEnable,
          mapView,
          isSecondMap,
          forceVisible
        );
      }
    });
  }
  static removeAdded3DLayers(mapView) {
    let defaultLayerClone = config.DEFAULT_LAYERS[`3D_OBJ`];
    BookmarkUtils.fromJson(mapView, defaultLayerClone);
  }
}
